// @flow strict

import { SET_STEP } from '../constants/stepTypes';

export type StepType = {
  descriptKey: string,
  pathName: ?string,
  section: ?number,
  step: number,
  type: string,
};

export function setStep(step: number, descriptKey: string, pathName: ?string, section: ?number) {
  return {
    type: SET_STEP,
    step,
    descriptKey,
    pathName,
    section,
  };
}
